import { render, staticRenderFns } from "./OverviewList.vue?vue&type=template&id=be395408&scoped=true&"
import script from "./OverviewList.vue?vue&type=script&lang=js&"
export * from "./OverviewList.vue?vue&type=script&lang=js&"
import style0 from "./OverviewList.vue?vue&type=style&index=0&id=be395408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be395408",
  null
  
)

export default component.exports